module.exports = __webpack_public_path__ + "static/key-goatofduty-2b7c2e625bf89c4ff8b194ad64738952.webp";